class PressSection extends HTMLElement {
  constructor() {
    super();
    this.lists = this.querySelectorAll('press-list');
    this.activeItemId = 1;
  }

  setActiveItem(id, listId = null) {
    if (!id || id === this.activeItemId) return;

    this.activeItemId = id;

    this.lists.forEach(list => {
      list.setActiveClass(id);

      if (list.dataset.listId !== listId || !listId) {
        list.scrollToItem(id);
      }
    });
  }

  lockLists() {
    this.lists.forEach(list => list.lock());
  }

  releaseLists() {
    this.lists.forEach(list => list.release());
  }

  setFocus(listId) {
    this.lists.forEach(list => {
      if (listId === list.listId) {
        list.release();
      } else {
        list.lock();
      }
    });
  }
}

customElements.define('press-section', PressSection);

class PressList extends HTMLElement {
  constructor() {
    super();
    this.listId = this.dataset.listId;
    this.parent = this.closest('press-section');
    this.scrollActions = this.parent.classList.contains('press--scroll-actions');
    this.items = Array.from(this.querySelectorAll('[data-press-item]'));
    this.mql = window.matchMedia('(min-width: 768px)');

    if (!this.parent) return;

    this.locked = true;
    this.activeItem = 1;
    this.firstItem = this.items[0];
    this.lastItem = this.items[this.items.length - 1];
    this.handleScroll = debounce(this.onScroll.bind(this), 500);
    this.handleFocus = this.takeFocus.bind(this);
    this.handleClick = this.onClick.bind(this);
  }

  connectedCallback() {
    if (this.scrollActions) {
      this.addEventListener('scroll', this.handleScroll);
      this.addEventListener('mousemove', this.handleFocus);
      this.addEventListener('touchmove', this.handleFocus);
    }

    if (this.classList.contains('press__media')) {
      this.onResize();
      window.addEventListener('resize', this.onResize.bind(this));
    }
    this.items.forEach(item => item.addEventListener('click', this.handleClick));
  }

  disconnectedCallback() {
    if (this.scrollActions) {
      this.removeEventListener('scroll', this.handleScroll);
      this.removeEventListener('mousemove', this.handleFocus);
      this.removeEventListener('touchmove', this.handleFocus);
    }

    if (this.classList.contains('press__media')) window.removeEventListener('resize', this.onResize.bind(this));
    this.items.forEach(item => item.removeEventListener('click', this.handleClick));
  }

  takeFocus() {
    if (this.locked) {
      this.parent.setFocus(this.listId);
    }
  }

  onClick(e) {
    this.activeItem = e.currentTarget.dataset.pressId;
    this.parent.setActiveItem(this.activeItem);
  }

  onScroll(e) {
    if (!this.locked) {
      this.activeItem = this.getCurrentItem();
      this.parent.setActiveItem(this.activeItem, this.listId);
    }
  }

  getCurrentItem() {
    return this.mql.matches ? Math.round(this.scrollTop / this.lastItem.clientHeight) + 1 : Math.round(this.scrollLeft / this.lastItem.clientWidth) + 1;
  }

  setActiveClass(id) {
    for (const item of this.items) {
      if (item.dataset.pressId == id) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    }
  }

  lock() {
    this.locked = true;
  }

  release() {
    this.locked = false;
  }

  scrollToItem(id) {
    if (window.scrollY === 0 || window.scrollY > this.offsetTop) {
      window.scrollTo({
        top: this.offsetTop - document.querySelector('.header-wrapper').offsetHeight,
      })
    }

    const target = this.items.find(item => item.dataset.pressId == id);

    const destination = this.mql.matches ? { top: target.offsetTop } : { left: target.offsetLeft };
    this.scrollTo(destination);
  }

  onResize() {
    if (!this.mql.matches) {
      let window_width = window.innerWidth;
      this.style.cssText += `--press-item-width: ${window_width}px;`;
    } else {
      this.style.cssText += "--press-item-width: ;";
    }
  }
}

customElements.define('press-list', PressList);
